import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../store";

interface LoginPayload  { email: string; password: string; }
interface SignupPayload {
  email: string; password: string; name: string; segment?: string;
  /** v1.1 (sent only when the matching launch flag is on) */
  acceptTerms?: boolean; website?: string; formFillMs?: number;
}

export function useMe() {
  const token = useAuthStore(s => s.token);
  return useQuery({
    queryKey: ["me"],
    queryFn:  async () => {
      const { data } = await axios.get("/api/auth/me");
      return data;
    },
    enabled: !!token,
  });
}

export function useLogin() {
  const setAuth = useAuthStore(s => s.setAuth);
  return useMutation({
    mutationFn: async (payload: LoginPayload) => {
      const { data } = await axios.post("/api/auth/login", payload);
      return data;
    },
    onSuccess: (data) => setAuth(data.accessToken, data.user),
  });
}

export function useSignup() {
  const setAuth = useAuthStore(s => s.setAuth);
  return useMutation({
    mutationFn: async (payload: SignupPayload) => {
      const { data } = await axios.post("/api/auth/register", payload);
      return data;
    },
    onSuccess: (data) => setAuth(data.accessToken, data.user),
  });
}

export function useLogout() {
  const logout = useAuthStore(s => s.logout);
  return useMutation({
    mutationFn: async () => {
      await axios.post("/api/auth/logout").catch(() => {});
    },
    onSettled: logout,
  });
}
